import logo from './logo.svg';
import './App.css';
import React, { useState, useEffect, useContext } from 'react';
import { Routes, BrowserRouter as Router, Route } from "react-router-dom"
import Cookies from "js-cookie";
import axios from "axios";

import Home from './pages/Home'
import MobileHome from './pages/MobileHome'
import LandscapeHome from './pages/LandscapeHome.js';
import CharsheetMobile from './components/CharsheetMobile/CharsheetMobile.js'
import Newsletter from './pages/Newsletter'
import Oauth2Handler from './Oauth2Handler.js'

import SongPlayer from './components/SongPlayer.js'
import Spellbook from './components/Spell/Spellbook.jsx';

import getAllSpells from './components/Spell/helpers/getAllSpells.js'
import getUserData from './helpers/getUserData.js'
import getAllUsers from './helpers/getAllUsers.js'
import createUser from './helpers/createUser.js'
import getDeviceInfo from './helpers/getDeviceInfo.js';
import getCampaignData from './helpers/getCampaignData.js';
import { DEFAULT_CAMPAIGN, charsheetAPI } from './globals.js';

import './fonts.css';
import { get } from 'jquery';
import { use } from 'react';

export const UserDataContext = React.createContext({username: 'Log In', uniqueUser: 'none', loggedIn: false });
// userData is set via a call to ./helpers/getUserData

// const addFont = require('add-font');
// addFont('./assets/fonts/Papyrus.TTF', 'Papyrus');

function App() {

  console.log('.'); console.log('.');
  console.log('--- APP START ---')

  // ---------- LOAD COOKIES ----------
  
  let cookieChar = 'Sample Character';
  let currentCampaign = DEFAULT_CAMPAIGN;

  try {
    if (Cookies.get("currentCampaign") === undefined) {
    Cookies.set("currentCampaign", DEFAULT_CAMPAIGN, { expires: 365 });
    }
    else { currentCampaign = Cookies.get("currentCampaign") }

    if (Cookies.get("currentChar") === undefined) {
      Cookies.set("currentChar", cookieChar)
    }
    let characterJSON = Cookies.get("currentChar");
    cookieChar = characterJSON;

    let campaignJSON = Cookies.get("currentCampaign")
    if (campaignJSON === undefined) { campaignJSON = DEFAULT_CAMPAIGN }

    currentCampaign = campaignJSON; // don't need to parse, it's a string
    // currentCampaign = JSON.parse(campaignJSON) ;
    console.log('cookieChar:', cookieChar, 'currentCampaign:', currentCampaign);
  }
  catch (error) {
  console.log('Error loading cookie:', error);
    // cookieChar = 'Sample Character' ;
  }

  // ---------- GLOBAL STATE VARIABLES ----------

  var [ currentChar, setChar ] = useState( cookieChar );
      console.log('App:', currentChar,' cookieChar:',cookieChar);

  var loggedIn = false;   // delete? may only be used in globalState, and has been replaced? by userData.loggedIn
  var discordCount = 0;
  
  const [ layout, setLayout ] = useState("");

  const currentSpellArray= useState("Knock");
  const currentSpellDataArray= useState({});

  const getSpellsArray = useState([])
  const spellsFilter = useState({ Class: ['Cleric', 'Druid', 'Mage', 'Illusion'], Lvl: [1,2,3,4,5,6,7,8,9] })
  const allSpellsArray = [...getSpellsArray, ...spellsFilter]

  const musicPlayingArray = useState(undefined);

  // -- GLOBAL STATE DEFINITION --
  // use caution when changing globalState as many components access this via direct indexing, e.g. globalState[6]

  let globalState = [ 
    /* 0 */ currentChar, 
    /* 1 */ setChar,
    /* 2 */ loggedIn,
    /* 3 */ layout, 
    /* 4 */ setLayout, 
    /* 5 */ currentSpellArray, 
    /* 6 */ currentSpellDataArray, 
    /* 7 */ allSpellsArray,
    /* 8 */ musicPlayingArray ];

  // -- USER DATA DEFINITION. This is a context variable --
  const [ userData, setUserData ] = useState(useContext(UserDataContext));

  
  const [isMobile, setIsMobile] = useState(/Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
  
  // ---------- useEffect ----------
  useEffect(() => {

    const fetchSpells = async () => {
      const spells = await getAllSpells(undefined, 'App');
      getSpellsArray[1](spells); // setSpellsArray(getAllSpells);
    };

    const setDocumentProperties = () => {
      document.body.style.setProperty('--vw', document.documentElement.clientWidth)
      document.body.style.setProperty('--vh', document.documentElement.clientHeight)
      document.body.style.setProperty('--orientation', 2)
      console.log('isMobile: ', isMobile)
      console.log('navigator.userAgent ',navigator.userAgent)
      // use devicePixelRatio to detect default orientation
      // if (window.devicePixelRatio > 2 )
      if ( isMobile )
        setLayout("mobile")
      else
        setLayout("full")
    };
    
    const recordDevice = (deviceDataDynamo, deviceInfo, userID) => {
      const inList = deviceDataDynamo.some(d => d.useragent === deviceInfo.useragent && d.user === userID);
      if (inList) {
        console.log('Device stored in database already');
        return;
      }
      console.log('Device not found in database...adding new device for ' + userID);
      const newArray = [...deviceDataDynamo, { user: userID, ...deviceInfo }];
      createUser('devices', "", newArray);
    };

    const fetchDiscordAndDeviceData = async () => {

      // ---------- GET DEVICE INFO ----------
      const deviceInfo = await getDeviceInfo();
      console.log('deviceInfo:', deviceInfo);

      const deviceUserDataDynamo = await getUserData('devices');
      const deviceDataDynamo = deviceUserDataDynamo.campaigns;
      console.log('deviceDataDynamo', deviceDataDynamo);

      // ---------- CHECK SESSION (server-verified via httpOnly cookie) ----------
      let session = null;
      try {
        const sessionRes = await axios.get(
          charsheetAPI + '?TableName=session-check',
          { withCredentials: true }
        );
        if (sessionRes.data && sessionRes.data.status === 'ok') {
          session = sessionRes.data;
        }
      } catch (err) {
        console.log('No active session');
      }

      if (session) {
        const userID = session.username;
        // session.userData is a snapshot baked into the server-side session at
        // login time, so it goes stale after any later write to charsheet-users
        // (from this or another tab). Re-fetch the live row so dynamoData is
        // current; fall back to the session snapshot if the fetch fails.
        const freshUserData = await getUserData(userID);
        const userDataDynamo = freshUserData || session.userData;
        const userAlias = session.global_name || (userDataDynamo && userDataDynamo.username_alias) || userID;

        const allUsers = await getAllUsers();

        recordDevice(deviceDataDynamo, deviceInfo, userID);

        if (allUsers.includes(userID)) {
          console.log('User already exists in database:', userID);
        } else {
          console.log('User not found...creating new user:', userID);
          createUser(userID, userAlias);
        }

        const campaignDataResult = await getCampaignData(currentCampaign);
        setUserData({
          username: userAlias,
          uniqueUser: userID,
          loggedIn: true,
          dynamoData: userDataDynamo,
          currentCampaign: currentCampaign,
          campaignData: campaignDataResult,
        });
      } else {
        recordDevice(deviceDataDynamo, deviceInfo, 'none');
      }
    };

    // ------  CODE FOR INITIAL LOAD OF APP -----

    fetchSpells();
    setDocumentProperties();

    // FETCH CAMPAIGN DATA (unconditional — runs regardless of login state)
    getCampaignData(currentCampaign).then(data => {
      if (data) setUserData(prev => ({ ...prev, campaignData: data }));
    });

    // FETCH DEVICE AND USER DATA
    discordCount += 1;
    if (discordCount < 2)
      fetchDiscordAndDeviceData();

    console.log('--vw', document.body.style.getPropertyValue('--vw'))
    console.log('--vh', document.body.style.getPropertyValue('--vh'))
    console.log('--vwlong', document.body.style.getPropertyValue('--viewport-width'))
    console.log('--wdevice', document.body.style.getPropertyValue('--device-width'))
    console.log('--density', window.devicePixelRatio )
    
    // alert(window.devicePixelRatio)
    // alert(document.documentElement.clientWidth + ' ' +window.screen.width + ' x ' + window.screen.height + ' ' + window.innerWidth + ' x ' + window.innerHeight + ' ratio' + window.devicePixelRatio + ' ' + pixelDensity)  
    
  }, [ ] );

  useEffect(() => {
    if (!document.getElementById('helpWindow')) return
    console.log(userData)
    const firstTimeUser = Cookies.get('ADM-firstTime');
    if (firstTimeUser === undefined) {
      console.log('First time user detected');
      Cookies.set('ADM-firstTime', 'true', { expires: 3650 });
      // turn on help window
      document.getElementById('helpWindow').style.display = 'block';
    }
    else if (firstTimeUser === 'true') {
      document.getElementById('helpWindow').style.display = 'block';
      }

    

  }, [ userData, layout ] );


  // ---------- return HTML (jsx) ----------
  return (
    <div id='main-app'>
      
      <UserDataContext.Provider value={[userData, setUserData]} >
        <Router>
          <Routes>
            <Route
              path="/"
              element={
                layout === '' ? (
                  <div>Loading...</div>
                ) : (
                  layout.includes('mobile') ? (
                    <MobileHome state={globalState} />
                  ) : layout === 'landscape' ? (
                    <LandscapeHome state={globalState} />
                  ) : (
                    <Home state={globalState} />
                  )
                )
              }
            />
            <Route path='/p' element={<Home state={ globalState } />} />
            <Route path='/w' element={<LandscapeHome state={ globalState } />} />
            <Route path='/m' element={<MobileHome state={ globalState } />} />
            <Route path='/oauth2/callback' element={<Oauth2Handler />} />
            <Route path='/s' element={<Spellbook state={ globalState } />} />
            <Route path='/News' element={<Newsletter state={ globalState } />} />
          </Routes>
        </Router>

      { userData.loggedIn ? <SongPlayer state={globalState}/> : <></> }
      </UserDataContext.Provider>
    </div>
    
      


  );
}

export default App;
